import React, { useEffect, useMemo } from "react";
import {
  makeStyles, createStyles, Theme, Grid,
  TextField, FormControl, Button, Typography, CircularProgress, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText, Checkbox, IconButton,
} from "@material-ui/core";
import { green } from '@material-ui/core/colors';
import DeleteIcon from '@material-ui/icons/Delete';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFile';
import { typeQaContent, typeQaEnvironment, typeUpdateForm, typeUserInfoList } from '../../../../api/helpline/qa'
import { DropzoneArea } from "material-ui-dropzone";
import { typeCategory } from "../../../../api/helpline/master";
import QABasicEdit from "./QABasicEdit";
import { typeUserInfo } from "../../../../api/helpline/user";
import { Autocomplete } from '@material-ui/lab';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { typeContractItemList } from "../../../../api/helpline/keiyaku";
import { adminUser } from "../../../../User";
import { useGlobalState } from "../../../../provider/Provider";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginTop: theme.spacing(3),
    },
    textfield: {
      width: "100%"
    },
    note: {
      marginTop: theme.spacing(2),
      width: "80%"
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: "2px",
      marginLeft: -12,
    },
    downloadProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -24,
      marginLeft: -24,
    },
    attachedbutton: {
      width: "30px",
      height: "30px",
      marginLeft: theme.spacing(1)
    },
    previewChip: {
      minWidth: "80px",
      maxWidth: "250px",
    },
    attachedArea: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    fieildset: {
      margin: '0',
    },
    time: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '70px'
    },
    incident: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '110px'
    },
    attachedIcon: {
      width: '30px'
    },
    attachedremoveButton: {
      width: '25px'
    }
  }),
);


interface FormProp {
  form: typeUpdateForm,
  loading: boolean,
  submitcount: number | null,
  qaContent: typeQaContent | undefined,
  qastatus: typeCategory[] | undefined,
  handleChangeFile: (files: File[]) => Promise<void>,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  onSubmit: () => void,
  qaEnv: typeQaEnvironment | undefined,
  userInfo: typeUserInfo | undefined,
  userInfoList: typeUserInfoList | undefined,
  handleError: (err: any) => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleCloseBasicEdit: () => void,
  handleAddSubmitCount: () => void,
  qabasicEdit: boolean,
  qastatusorg: typeCategory[] | undefined,
  answerway: typeCategory[] | undefined,
  handleRemoveFile: (filename: string) => string,
  hadleChangeCloseForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => void,
  questionkind: typeCategory[] | undefined,
  handleChangeMinutes: (value: string) => void,
  totaltime: {
    hours: string;
    minutes: string;
    isNum: boolean;
  },
  closeform: {
    qaKindClsCd: string;
    qaTotalTime: number;
    incidentUse: number;
    incidentAddFlg: string;
  },
  incidentAddFlg: boolean,
  handleincidentAddFlg: (event: React.ChangeEvent<HTMLInputElement>) => void,
  incidentcheck: boolean,
  incidentReqired: boolean,
  handleQARestEditClose: () => void,
  editindex: number,
  fileloading: boolean,
  fileDownload: (filepath: string) => void,
  fileRemoveButton: (index: number) => void,
  newfiles: {
    attachedFile: string;
    attachedFileData: string;
    attachedFile2: string;
    attachedFile2Data: string;
    attachedFile3: string;
    attachedFile3Data: string;
  },
  selectKeiyaku: typeContractItemList | undefined,
  handleDeleteOpen: () => void,
}
const MAX_FILESIZE: number = Number(process.env.REACT_APP_MAX_FILESIZE!)
const MAX_FILENUMBER = 3
const newservice = process.env.REACT_APP_KEIYAKU_NEW_SERVICE!
const appservice = process.env.REACT_APP_KEIYAKU_NEW_APP!
const webservice = process.env.REACT_APP_KEIYAKU_NEW_WEBTECHINICAL!

const FormArea: React.FC<FormProp> = (props) => {
  const classes = useStyles()
  const { loading, form, qaContent, qastatus, qastatusorg, handleChangeFile, handleChangeForm, onSubmit, submitcount, qaEnv, userInfo, userInfoList, handleError, handleNotificationOpen, handleCloseBasicEdit, handleAddSubmitCount, qabasicEdit, answerway, handleRemoveFile, hadleChangeCloseForm, questionkind, handleChangeMinutes, closeform, totaltime, incidentAddFlg, handleincidentAddFlg, incidentcheck, incidentReqired, handleQARestEditClose, editindex, fileloading, fileDownload, fileRemoveButton, newfiles, selectKeiyaku, handleDeleteOpen } = props

  return (
    <React.Fragment>
      {
        qaContent && qaContent.qaStatusClsCd === '0' &&
        <Grid container justify="center" >
          <Grid item xs={12}>
            <Grid container direction="row" justify="center" alignItems="center">
              {qaContent && qaContent.qaStatusClsCd && qastatus && qastatus.length !== 0 && editindex === -1 &&
                <FormControl component="fieldset" variant="outlined" className={classes.fieildset} disabled={loading}>
                  <FormLabel component="legend">ステータス</FormLabel>
                  <RadioGroup row id="qaStatusClsCd" name="qaStatusClsCd" onChange={handleChangeForm} value={form.qaStatusClsCd}>
                    {qastatus.map(value => {
                      return (<FormControlLabel
                        value={value.categoryCd}
                        control={<Radio color="primary" size="small" />}
                        label={value.categoryName}
                      />)
                    })}
                  </RadioGroup>
                </FormControl>
              }
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {form.qaStatusClsCd === '1' ? (
              <QABasicEdit qaContent={qaContent} qaEnv={qaEnv} userInfo={userInfo} userInfoList={userInfoList} handleError={handleError} handleNotificationOpen={handleNotificationOpen} handleCloseBasicEdit={handleCloseBasicEdit} handleAddSubmitCount={handleAddSubmitCount} qabasicEdit={qabasicEdit} />
            ) : form.qaStatusClsCd === '0' && editindex === -1 ? (
              <React.Fragment></React.Fragment>
            ) : (
              <Form qaContent={qaContent} form={form} loading={loading} handleChangeFile={handleChangeFile} handleChangeForm={handleChangeForm} submitcount={submitcount} onSubmit={onSubmit} qastatusorg={qastatusorg} answerway={answerway} handleRemoveFile={handleRemoveFile} hadleChangeCloseForm={hadleChangeCloseForm} questionkind={questionkind} handleChangeMinutes={handleChangeMinutes} totaltime={totaltime} closeform={closeform} incidentAddFlg={incidentAddFlg} handleincidentAddFlg={handleincidentAddFlg} incidentcheck={incidentcheck} incidentReqired={incidentReqired} selectKeiyaku={selectKeiyaku} handleQARestEditClose={handleQARestEditClose} editindex={editindex} fileloading={fileloading} fileDownload={fileDownload} fileRemoveButton={fileRemoveButton} newfiles={newfiles} handleDeleteOpen={handleDeleteOpen} />)}
          </Grid>
        </Grid>
      }
      {qaContent && qaContent.qaStatusClsCd !== '0'
        && <Form qaContent={qaContent} form={form} loading={loading} handleChangeFile={handleChangeFile} handleChangeForm={handleChangeForm} submitcount={submitcount} onSubmit={onSubmit} qastatusorg={qastatusorg} answerway={answerway} handleRemoveFile={handleRemoveFile} hadleChangeCloseForm={hadleChangeCloseForm} questionkind={questionkind} handleChangeMinutes={handleChangeMinutes} totaltime={totaltime} closeform={closeform} incidentAddFlg={incidentAddFlg} handleincidentAddFlg={handleincidentAddFlg} incidentcheck={incidentcheck} incidentReqired={incidentReqired} selectKeiyaku={selectKeiyaku} handleQARestEditClose={handleQARestEditClose} editindex={editindex} fileloading={fileloading} fileDownload={fileDownload} fileRemoveButton={fileRemoveButton} newfiles={newfiles} handleDeleteOpen={handleDeleteOpen} />}
    </React.Fragment>)
}

interface priProps {
  qaContent: typeQaContent | undefined,
  form: typeUpdateForm,
  loading: boolean,
  handleChangeFile: (files: File[]) => Promise<void>,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  submitcount: number | null,
  onSubmit: () => void,
  qastatusorg: typeCategory[] | undefined,
  answerway: typeCategory[] | undefined,
  handleRemoveFile: (filename: string) => string,
  hadleChangeCloseForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => void,
  questionkind: typeCategory[] | undefined,
  handleChangeMinutes: (value: string) => void,
  totaltime: {
    hours: string;
    minutes: string;
    isNum: boolean;
  },
  closeform: {
    qaKindClsCd: string;
    qaTotalTime: number;
    incidentUse: number;
    incidentAddFlg: string;
  },
  incidentAddFlg: boolean,
  handleincidentAddFlg: (event: React.ChangeEvent<HTMLInputElement>) => void,
  incidentcheck: boolean,
  incidentReqired: boolean,
  handleQARestEditClose: () => void,
  editindex: number,
  fileloading: boolean,
  fileDownload: (filepath: string) => void,
  fileRemoveButton: (index: number) => void,
  newfiles: {
    attachedFile: string;
    attachedFileData: string;
    attachedFile2: string;
    attachedFile2Data: string;
    attachedFile3: string;
    attachedFile3Data: string;
  },
  selectKeiyaku: typeContractItemList | undefined,
  handleDeleteOpen: () => void,
}

const Form: React.FC<priProps> = (props) => {
  const { role } = useGlobalState('user')
  const classes = useStyles()
  const { qaContent, handleChangeForm, form, submitcount, handleChangeFile, onSubmit, loading, qastatusorg, answerway, handleRemoveFile, hadleChangeCloseForm, questionkind, handleChangeMinutes, closeform, totaltime, incidentAddFlg, handleincidentAddFlg, incidentReqired, incidentcheck, handleQARestEditClose, editindex, fileloading, fileDownload, fileRemoveButton, newfiles, selectKeiyaku, handleDeleteOpen } = props

  const minutes = ['0', '15', '30', '45']
  const maxfile = useMemo((): number => {
    const sumfiles = []
    for (const [key, value] of Object.entries(newfiles)) {
      if (key === 'attachedFile' || key === 'attachedFile2' || key === 'attachedFile3') {
        if (value) {
          sumfiles.push(key)
        }
      }
    }
    for (const [key, value] of Object.entries(form)) {
      if (key === 'attachedFile' || key === 'attachedFile2' || key === 'attachedFile3') {
        if (value) {
          sumfiles.push(key)
        }
      }
    }
    return sumfiles.length
  }, [newfiles, form.attachedFile, form.attachedFile2, form.attachedFile3])

  const totaltimecheck = useMemo(() => !totaltime.isNum ? true : closeform.qaTotalTime === 0, [totaltime.isNum, closeform.qaTotalTime])
  const contentscheck = useMemo(() => form.answerContents.length === 0, [form.answerContents])
  const check = useMemo(() => contentscheck ? true : form.qaStatusClsCd !== '4' ? false : !totaltime.isNum ? true : closeform.qaTotalTime === 0 ? true : incidentReqired && incidentcheck, [contentscheck, form.qaStatusClsCd, totaltime.isNum, closeform.qaTotalTime, incidentReqired, incidentcheck])

  const incidentform = useMemo(() => {
    if (selectKeiyaku?.keiyakuClsNotes === newservice || selectKeiyaku?.keiyakuClsNotes === appservice) {
      return true
    } else { return false }
  }, [selectKeiyaku])

  const disableincident = useMemo(() => {
    if (!incidentReqired) {
      return true
    } else if (selectKeiyaku?.keiyakuClsNotes === newservice) {
      return true
    } else if (selectKeiyaku?.keiyakuClsNotes === appservice) {
      if (loading) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }, [selectKeiyaku, loading, incidentReqired])

  const views = useMemo((): boolean => {
    if (qaContent) {
      if (qaContent.qaStatusClsCd === '4') {
        if (editindex !== -1) {//qa回答編集は表示
          return true
        } else {
          return false
        }
      } else {//ステータス終了以外は表示
        return true
      }
    } else {
      return false
    }
  }, [editindex, qaContent])

  const [dropview, setDropview] = React.useState(true)

  useEffect(() => {
    setDropview(false)
    setTimeout(() => {
      setDropview(true)
    }, 500);
  }, [editindex, submitcount])

  const qaStatusView = useMemo((): boolean => {
    if (qaContent && qastatusorg && qastatusorg.length !== 0) {
      if (qaContent.qaStatusClsCd !== '0') {
        return true
      } else if (editindex !== -1) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }, [qaContent, qastatusorg, editindex])

  return (
    <React.Fragment>
      {editindex !== -1 &&
        < Grid container direction="row" justify="flex-start">
          <Typography variant="subtitle1" style={{ flexGrow: 1 }}>
            Q&A回答編集
          </Typography>
          {adminUser(role) && <Button variant="outlined" color="secondary" size='small' onClick={handleDeleteOpen} style={{ marginRight: '4px' }} startIcon={<DeleteIcon />}>削除</Button>}
          <Button variant="outlined" color="primary" size='small' onClick={handleQARestEditClose} >キャンセル</Button>
        </Grid >
      }
      {
        views && (
          <Grid container justify="center">
            <Grid item xs={12}>
              {qaStatusView &&
                <FormControl component="fieldset" variant="outlined" className={classes.fieildset} disabled={loading}>
                  <FormLabel component="legend">ステータス</FormLabel>
                  <RadioGroup row id="qaStatusClsCd" name="qaStatusClsCd" onChange={handleChangeForm} value={form.qaStatusClsCd}>
                    {qastatusorg?.filter(value => value.categoryCd === '2' || value.categoryCd === '3' || value.categoryCd === '4' || value.categoryCd === 'd').map(value => {
                      if (value.categoryCd === '2') {
                        return (<FormControlLabel
                          value={value.categoryCd}
                          control={<Radio color="primary" size="small" />}
                          label={'回答(CIS→お客様)'}
                        />)
                      } else if (value.categoryCd === '3') {
                        return (<FormControlLabel
                          value={value.categoryCd}
                          control={<Radio color="primary" size="small" />}
                          label={'応答(お客様→CIS)'}
                        />)
                      } else {
                        return (<FormControlLabel
                          value={value.categoryCd}
                          control={<Radio color="primary" size="small" />}
                          label={value.categoryName}
                        />)
                      }
                    })}
                  </RadioGroup>
                </FormControl>
              }
            </Grid>
            <Grid item xs={12}>
              {qaContent && qaContent.qaStatusClsCd && answerway && answerway.length !== 0 &&
                <FormControl component="fieldset" variant="outlined" className={classes.fieildset} disabled={loading}>
                  <FormLabel component="legend">回答方法</FormLabel>
                  <RadioGroup row id="answerClsCd" name="answerClsCd" onChange={handleChangeForm} value={form.answerClsCd}>
                    {answerway.map(value => {
                      return (<FormControlLabel
                        value={value.categoryCd}
                        control={<Radio color="primary" size="small" />}
                        label={value.categoryName}
                        disabled={form.qaStatusClsCd === '3' && value.categoryCd === '6' ? true : loading}
                      />)
                    })}
                  </RadioGroup>
                </FormControl>
              }
            </Grid>
            {form.qaStatusClsCd === "4" &&
              <React.Fragment>
                <Grid item xs={12}>
                  <Grid xs={12}>
                    <Typography variant="caption">対応時間</Typography>
                  </Grid>
                  <Grid container direction="row" justify="flex-start" alignItems="center">
                    <Grid item>
                      <TextField className={classes.time} required id="hours" label="時間" variant="outlined" size='small' name="hours" onChange={hadleChangeCloseForm} value={totaltime.hours} disabled={loading} error={totaltimecheck} />
                    </Grid>
                    <Grid item>
                      <FormControl className={classes.time} variant="outlined" margin="dense" disabled={loading} error={totaltimecheck}>
                        <Autocomplete
                          id="munutes"
                          disableClearable={true}
                          options={minutes}
                          value={totaltime.minutes}
                          getOptionLabel={(option) => option}
                          onChange={(event, value) => handleChangeMinutes(value)}
                          renderInput={(params) => (
                            <TextField {...params} label="分" variant="outlined" size="small" required error={totaltimecheck} />
                          )}
                          renderOption={(option, { inputValue }) => {
                            const matches = match(option, inputValue);
                            const parts = parse(option, matches);
                            return (
                              <div>
                                {parts.map((part, index) => (
                                  <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                  </span>
                                ))}
                              </div>
                            );
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item>
                      {totaltimecheck && <FormHelperText error={totaltimecheck}>有効な整数値を入力して下さい</FormHelperText>}
                    </Grid>
                  </Grid>
                </Grid>
                {incidentform &&
                  <Grid item xs={12}>
                    <Grid container direction="row" justify="flex-start" alignItems="center">
                      <Grid item>
                        <TextField className={classes.incident} required id="incidentUse" label="インシデント" variant="outlined" size='small' name="incidentUse" onChange={hadleChangeCloseForm} value={closeform.incidentUse} disabled={disableincident} error={incidentReqired && incidentcheck} />
                      </Grid>
                      <Grid item>
                        <FormControlLabel control={<Checkbox checked={incidentAddFlg} color="primary" onChange={handleincidentAddFlg} name="incidentAddFlg" size="small" />} label="追加" />
                      </Grid>
                      <Grid item>
                        {incidentReqired && incidentcheck && < FormHelperText error>有効な数値を入力して下さい(小数点以下は0.5単位)</FormHelperText>}
                      </Grid>
                    </Grid>
                  </Grid>
                }
                <Grid item xs={12}>
                  {questionkind && questionkind.length !== 0 &&
                    < FormControl component="fieldset" variant="outlined" className={classes.fieildset} disabled={loading}>
                      <FormLabel component="legend">問合せ区分</FormLabel>
                      <RadioGroup row id="qaKindClsCd" name="qaKindClsCd" onChange={hadleChangeCloseForm} value={closeform.qaKindClsCd}>
                        {questionkind.map(value => {
                          return (<FormControlLabel
                            value={value.categoryCd}
                            control={<Radio color="primary" size="small" />}
                            label={value.categoryName}
                          />)
                        })}
                      </RadioGroup>
                    </FormControl>
                  }
                </Grid>
              </React.Fragment>
            }
            <Grid item xs={12}>
              <FormControl className={classes.lWidth} margin="dense" variant="outlined" error={contentscheck}>
                <TextField className={classes.textfield} required id="answerContents" label="回答内容" multiline variant="outlined" size='small' name="answerContents" onChange={handleChangeForm} value={form.answerContents} disabled={loading} error={contentscheck} />
                {contentscheck && <FormHelperText>必須項目です</FormHelperText>}
                <FormHelperText>複数行入力できます</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField className={classes.note} id="note" label="備考" multiline variant="outlined" size='small' name="note" onChange={handleChangeForm} value={form.note} disabled={loading} />
              <FormHelperText>複数行入力できます</FormHelperText>
            </Grid>
            <Grid item xs={12} md={8}>
              <FormControl variant="outlined" className={classes.attachedArea} >
                <Typography variant="caption">添付ファイル</Typography>
                {editindex !== -1 && (
                  <React.Fragment>
                    <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                      {form.attachedFile &&
                        <React.Fragment>
                          <Grid item>
                            <IconButton component="span" size="small" className={classes.attachedIcon} disabled={fileloading} onClick={(event: any) => fileDownload(form.attachedFile!)}>
                              <AttachFileOutlinedIcon fontSize="small" />
                              {fileloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </IconButton>
                          </Grid>
                          <Grid item>
                            <Button variant="outlined" color="secondary" className={classes.attachedremoveButton} size="small" onClick={(event) => fileRemoveButton(1)}>削除</Button>
                          </Grid>
                        </React.Fragment>
                      }
                      {form.attachedFile2 &&
                        <React.Fragment>
                          <Grid item>
                            <IconButton component="span" size="small" className={classes.attachedIcon} disabled={fileloading} onClick={(event: any) => fileDownload(form.attachedFile2!)}>
                              <AttachFileOutlinedIcon fontSize="small" />
                              {fileloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </IconButton>
                          </Grid>
                          <Grid item>
                            <Button variant="outlined" color="secondary" className={classes.attachedremoveButton} size="small" onClick={(event) => fileRemoveButton(2)}>削除</Button>
                          </Grid>
                        </React.Fragment>
                      }
                      {form.attachedFile3 &&
                        <React.Fragment>
                          <Grid item>
                            <IconButton component="span" size="small" className={classes.attachedIcon} disabled={fileloading} onClick={(event: any) => fileDownload(form.attachedFile3!)}>
                              <AttachFileOutlinedIcon fontSize="small" />
                              {fileloading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </IconButton>
                          </Grid>
                          <Grid item>
                            <Button variant="outlined" color="secondary" className={classes.attachedremoveButton} size="small" onClick={(event) => fileRemoveButton(3)}>削除</Button>
                          </Grid>
                        </React.Fragment>
                      }
                    </Grid>
                    <Grid item>
                      {maxfile > MAX_FILENUMBER && <FormHelperText error>{`${maxfile - MAX_FILENUMBER}個の添付ファイルを削除してください`}</FormHelperText>}
                    </Grid>
                  </React.Fragment>
                )}
                {dropview &&
                  <DropzoneArea
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    getFileRemovedMessage={(fileName: string) => handleRemoveFile(fileName)}
                    useChipsForPreview
                    filesLimit={MAX_FILENUMBER}
                    dropzoneText={"ファイルをここにアップロード"}
                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                    previewChipProps={{ classes: { root: classes.previewChip }, color: 'primary', size: 'small' }}
                    previewText=""
                    showAlerts={['error']}
                    maxFileSize={MAX_FILESIZE}
                    getDropRejectMessage={(rejectedFile: File, acceptedFiles: string[], maxFileSize: number) => (`ファイルサイズの上限は${maxFileSize / 1024 / 1024}MBです`)}
                    getFileLimitExceedMessage={(fileLimit) => (`アップロード可能ファイル数は${fileLimit}です`)}
                    onChange={handleChangeFile}
                  />
                }
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} >
              <Grid container justify="flex-end" alignItems="flex-end">
                <Grid container direction="column" justify="center" alignItems="center">
                  <Grid item>
                    <div className={classes.wrapper}>
                      <Button variant="contained" color="primary" className={classes.button} size="large" disabled={check ? true : maxfile > MAX_FILENUMBER ? true : loading} onClick={() => onSubmit()}>
                        {editindex === -1 ? '送信' : '更新'}
                      </Button>
                      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                  </Grid>
                  <Grid item>
                    {check && !loading && <Typography color='error' variant="caption">未入力の必須項目があります</Typography>}
                    {maxfile > MAX_FILENUMBER && !loading && <Typography color='error' variant="caption">添付ファイルを削除してください</Typography>}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid >)
      }
    </React.Fragment >
  )
}


export default React.memo(FormArea)
